/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

// import { LogLevel } from "@azure/msal-browser";

const providers = window.providers;
const msProvider = providers&& providers.find((p) => p.name === "microsoft");
let auth;
if(msProvider) {
auth = {
  clientId: msProvider.clientId,
  authority: "https://login.microsoftonline.com/common/",
  redirectUri: msProvider.postbackURL,
};
}
else auth = null
/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: auth,
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                // switch (level) {		
                //     case LogLevel.Error:		
                //         console.error(message);		
                //         return;		
                //     case LogLevel.Info:		
                //         console.info(message);		
                //         return;		
                //     case LogLevel.Verbose:		
                //         console.debug(message);		
                //         return;		
                //     case LogLevel.Warning:		
                //         console.warn(message);		
                //         return;		
                // }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us//active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read", "email"]
};